export function ListEmptySearchResults({
  onClear,
  children,
}: {
  onClear: () => void;
  children: React.ReactNode;
}) {
  return (
    <s-box padding="large-400">
      <s-stack direction="block" gap="base" alignItems="center">
        <s-icon type="search" />
        <s-text color="subdued">{children}</s-text>
        <s-button variant="tertiary" onClick={onClear}>
          Limpiar búsqueda
        </s-button>
      </s-stack>
    </s-box>
  );
}
